import {
  CrudEventEnum,
  EntityStatus,
  FatFingerDetail,
  FatFingerProductSectorLimit,
  Holiday,
  HolidayDetail,
  Organisation,
  OrganisationDetail,
  PrimeBroker,
  Status,
  TradingEntity,
  TradingEntityDetail,
  TradingEntityType,
  TradingRelationship
} from 'api'

export function newEmptyOrganisationDetailForAdd(): OrganisationDetail {
  const organisation: Organisation = {
    id: '',
    legalName: '',
    lei: '',
    organisationTypes: [],
    shortCode: '',
    status: EntityStatus.DISABLED,
    enabledFeatures: [],
    gfidCodes: [],
    enabledOrganisationFeatures: []
  }

  return {
    organisation,
    primeBrokers: [],
    availableEvents: [CrudEventEnum.UPSERT]
  }
}

export function newPrimeBrokerForAdd(id: string, name: string, organisationId: string): PrimeBroker {
  return {
    id,
    name,
    organisationId,
    status: EntityStatus.ENABLED
  }
}

export function newEmptyTradingEntityDetailForAdd(): TradingEntityDetail {
  const tradingEntity: TradingEntity = {
    id: '',
    bic: '',
    lei: '',
    shortName: '',
    publishedName: '',
    organisationId: '',
    productRights: [],
    settlementVenue: [],
    group: '',
    status: EntityStatus.DISABLED,
    tradingEntityTypes: [TradingEntityType.STANDARD],
    splitUsTrades: false,
    eligible15a6: false,
    eligibleCombinedRecFile: false,
    centralBank: false,
    negotiationHistoryFile: false,
    euGfidCode: null,
    usGfidCode: null,
    operatingCountry: null,
    roundPriceToOneEighth: false,
    ficcShortName: null
  }

  return {
    tradingEntity,
    organisation: null,
    tradingRelationships: [],
    tradingEntityMeta: [],
    availableEvents: [CrudEventEnum.UPSERT]
  }
}

export function newTradingRelationshipForAdd(buyTradingEntity: string, sellTradingEntity: string): TradingRelationship {
  return {
    id: '',
    buyTradingEntity,
    sellTradingEntity,
    usSponsoredClearing: false,
    usSponsoredClearingByDefault: false,
    masterLegalAgreements: [],
    defaultAgreement: null,
    status: Status.APPROVED,
    responderFiccToResponderFix: false,
    initiatorFiccToInitiatorFix: false,
    initiatorFiccToResponderFix: false,
    responderFiccToInitiatorFix: false
  }
}

export function newEmptyFatFingerDetailForAdd(): FatFingerDetail {
  const fatFinger: FatFingerProductSectorLimit = {
    amountRestriction: null!,
    amountWarn: null!,
    notionalAmountRestriction: null!,
    notionalAmountWarn: null!,
    cashAmountRestriction: null!,
    cashAmountWarn: null!,
    fixedRatePrice: null!,
    fixedRateWarnLevel: null!,
    fixedRateRestriction: null!,
    floatRateSpread: null!,
    floatRateWarnLevel: null!,
    floatRateRestriction: null!,
    productSectorId: ''
  }

  return {
    fatFinger,
    productSector: null,
    product: null,
    availableEvents: [CrudEventEnum.UPSERT]
  }
}

export function newEmptyHolidayDetailForAdd(): HolidayDetail {
  const holiday: Holiday = {
    currency: null!,
    holidays: [],
    status: EntityStatus.ENABLED
  }

  return {
    holiday,
    date: '',
    availableEvents: [CrudEventEnum.UPSERT]
  }
}
